import { render, staticRenderFns } from "./modelo_anio.vue?vue&type=template&id=994bd724"
import script from "./modelo_anio.vue?vue&type=script&lang=js"
export * from "./modelo_anio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports